module.exports = __webpack_public_path__ + "static/media/earnwell_logo.38a23b41.png";